export const dappResourcesConstants = {
    SET_DAPP_BALANCES_DATA: 'SET_DAPP_BALANCES_DATA'
};
